const prefix = "/finlive";

export const route = {
  default: prefix + "/home",

  // 홈
  home: prefix + "/home",

  // 검색
  search: prefix + "/search",

  // auth
  login: prefix + "/login",
  register: prefix + "/register",
  id_find: prefix + "/id_find",
  id_find_complete: prefix + "/id_find/complete",
  pw_find: prefix + "/pw_find",
  pw_change: prefix + "/pw_change",

  // 금융 스터디
  study_list: prefix + "/study/list",

  // 영상 강의
  lecture_list: prefix + "/lecture/list",
  lecture_detail: prefix + "/lecture/detail",
  lecture_onboarding_complete: prefix + "/lecture/onboarding/complete",
  lecture_payment: prefix + "/lecture/payment",
  lecture_payment_complete: prefix + "/lecture/payment/complete",
  lecture_payment_fail: prefix + "/lecture/payment/fail",

  // 금융 칼럼
  column_list: prefix + "/column/list",
  column_detail: prefix + "/column/detail",

  // 커뮤니티
  community_list: prefix + "/community/list",
  community_create: prefix + "/community/create",
  community_edit: prefix + "/community/edit",
  community_detail: prefix + "/community/detail",

  // 컨설팅
  consulting: prefix + "/consulting", // 1:1 컨설팅이란?
  consulting_prior: prefix + "/consulting/prior", // 사전 상담 받기
  consulting_prior_detail: prefix + "/consulting/prior/detail", // 사전 상담 받기 상세
  consulting_apply: prefix + "/consulting/apply", // 신청하기
  consulting_progress: prefix + "/consulting/progress", // 진행 중인 컨설팅
  consulting_progress_detail: prefix + "/consulting/progress/detail", // 진행 중인 컨설팅 상세
  consulting_detail: prefix + "/consulting/detail",
  consulting_payment: prefix + "/consulting/payment",

  // 고객센터
  customer_service_notice: prefix + "/customerService/notice", // 공지사항
  customer_service_ask: prefix + "/customerService/ask", // 1:1 문의
  customer_service_ask_my: prefix + "/customerService/ask/my", // 나의 문의 내역
  customer_service_ask_detail: prefix + "/customerService/ask/detail", // 1:1 문의 상세
  customer_service_ask_edit: prefix + "/customerService/ask/edit", // 1:1 문의 수정
  customer_service_ask_write: prefix + "/customerService/ask/write", // 1:1 문의 작성
  customer_service_faq: prefix + "/customerService/faq", // 자주 묻는 질문
  customer_service_terms_use: prefix + "/customerService/terms/use", // 약관 - 서비스 이용약관
  customer_service_terms_privacy: prefix + "/customerService/terms/privacy", // 약관 - 개인정보처리방침

  // 마이 페이지
  my_page_setting: prefix + "/myPage/setting", // 계정 관리
  my_page_setting_withdrawal: prefix + "/myPage/setting/withdrawal", // 회원 탈퇴

  my_page_activity: prefix + "/myPage/activity", // 내 활동 관리- 내가 쓴 글
  my_page_activity_comment: prefix + "/myPage/activity/comment", // 내 활동 관리- 내가 쓴 댓글
  my_page_activity_review: prefix + "/myPage/activity/review", // 내 활동 관리- 강의 후기 관리
  my_page_activity_review_edit: prefix + "/myPage/activity/review/edit", // 내 활동 관리- 강의 후기 수정
  my_page_activity_coupon: prefix + "/myPage/activity/coupon", // 내 활동 관리- 쿠폰 관리

  my_page_classroom: prefix + "/myPage/classroom", // 나의 강의실 - 수강 중인 강의
  my_page_classroom_complete: prefix + "/myPage/classroom/complete", // 나의 강의실 - 수강 완료 강의
  my_page_classroom_lecture: prefix + "/myPage/classroom/lecture", // 나의 강의실 - 강의실 강의
  my_page_classroom_review: prefix + "/myPage/classroom/review", // 나의 강의실 - 강의실 후기 작성

  my_page_scrap: prefix + "/myPage/scrap", // 스크랩 - 강의
  my_page_scrap_column: prefix + "/myPage/scrap/column", // 스크랩 - 칼럼

  my_page_payment: prefix + "/myPage/payment", // 결제 내역 - 구독 관리
  my_page_payment_subscribe: prefix + "/myPage/payment/subscribe", // 결제 내역 - 구독 결제
  my_page_payment_history: prefix + "/myPage/payment/history", // 결제 내역 - 결제 내역 조회
  my_page_payment_refund: prefix + "/myPage/payment/refund", // 결제 내역 - 환불 신청 내역
  my_page_payment_detail: prefix + "/myPage/payment/detail", // 결제 내역 - 결제 내역 상세
};
